import React, { useState } from 'react';
const FAQS = [{
  q: '📦 What is The Knee Geometry Method?',
  a: "It's a digital guide with a complete 15-day plan that rebuilds knee angles, stability, and walking confidence—at home, low impact."
}, {
  q: '📥 How do I receive the content?',
  a: 'Instantly! You get immediate access via email after purchase.'
}, {
  q: '🦵 Is this safe for my knee?',
  a: 'Yes. The program uses chair, wall, and resistance band exercises only. No impact, no deep knee bends. Plus the Pain Traffic Light system lets you adjust daily.'
}, {
  q: '🔥 What if I have a flare-up?',
  a: "The included 24-48 hour Flare-Up Protocol tells you exactly what to do so one bad day doesn't erase your progress."
}, {
  q: '⚠️ Who is this NOT for?',
  a: 'This is not medical treatment. If you have severe swelling, heat/redness, locking, sudden inability to bear weight, recent injury, or sharp escalating pain—see a doctor first.'
}, {
  q: '🏋️ What equipment do I need?',
  a: "A chair, a wall, and a resistance band. That's it. No gym required."
}];
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-[30px] px-[15px] bg-[#F8FAFB]" data-id="element-110">
      <div className="container max-w-[500px] mx-auto px-[15px]" data-id="element-111">
        <h2 className="text-[24px] text-center mb-[20px] font-[700] text-[#111827] font-['Montserrat']" data-id="element-112">
          🤔 Frequently Asked Questions
        </h2>

        {FAQS.map((faq, index) => <div key={index} className="mb-[12px] rounded-[8px] overflow-hidden shadow-[0_4px_10px_rgba(0,0,0,0.05)] bg-white" data-id="element-113">
            <div className={`p-[15px] font-[700] text-[16px] cursor-pointer relative ${openIndex === index ? 'active' : ''}`} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-114">
              {faq.q}
              <span className="absolute right-[15px] text-[22px] text-[#DC2626]" data-id="element-115">
                {openIndex === index ? '-' : '+'}
              </span>
            </div>
            <div className={`px-[15px] overflow-hidden transition-[max-height] duration-300 ease-in-out ${openIndex === index ? 'max-h-[300px]' : 'max-h-0'}`} data-id="element-116">
              <div className="py-[15px] text-[#374151]" data-id="element-117">
                <p data-id="element-118">{faq.a}</p>
              </div>
            </div>
          </div>)}

        <a className="block w-full bg-gradient-to-br from-[#DC2626] to-[#EF4444] text-white border-none p-[16px] text-[18px] font-[700] rounded-[50px] cursor-pointer shadow-[0_8px_20px_rgba(220,38,38,0.3)] text-center no-underline uppercase font-['Montserrat'] animate-pulse-custom hover:transform hover:-translate-y-[3px] hover:scale-[1.02] hover:shadow-[0_8px_20px_rgba(220,38,38,0.5)] transition-all duration-400 mt-[20px]" href="#get-the-method" data-id="element-119">
          Download The Knee Geometry Method
        </a>
      </div>
    </section>;
}